export function getSubject(type) {
  let subject, previewText;

  if (type === 'welcomeEmail' || type === 'confirmEmail') {
    subject = 'Please confirm your e-mail address';
    previewText = 'Action Required! Confirm your email.';
  }
  if (type === 'bookingRequest') {
    subject = 'You have a new reservation';
    previewText = 'Great News! You have a new reservation.';
  }
  if (type === 'bookingRequestGuest') {
    subject = 'Your reservation request was sent to the owner';
    previewText = 'Great News! Your reservation has been shared with the owner.';
  }
  if (type === 'bookingConfirmedToHost') {
    subject = 'You have confirmed a reservation';
    previewText = 'Confirmed Reservation Details';
  }
  if (type === 'bookingConfirmedToGuest') {
    subject = 'Your reservation is confirmed by the owner';
    previewText = 'Get ready for pickup!';
  }
  if (type === 'bookingDeclinedToGuest') {
    subject = 'Your reservation request was declined by the owner';
    previewText = 'We are sorry, your request was declined.';
  }
  if (type === 'bookingExpiredGuest') {
    subject = 'Your reservation request expired';
    previewText = 'We are sorry, your request expired.';
  }
  if (type === 'bookingExpiredHost') {
    subject = 'A reservation expired';
    previewText = 'A reservation expired.';
  }
  if (type === 'cancelled') {
    subject = 'Your reservation was cancelled';
    previewText = 'Your reservation was cancelled.';
  }
  if (type === 'completedGuest') {
    subject = 'Please write a review for the owner';
    previewText = 'Action Required! Write a review.';
  }
  if (type === 'completedHost') {
    subject = 'Please write a review for your renter';
    previewText = 'Action Required! Write a review.';
  }
  if (type === 'forgotPasswordLink') {
    subject = 'Reset your Password';
    previewText = 'Action Required! Reset your password.';
  }

  if (type === 'message') {
    subject = 'You have a new message';
    previewText = 'Someone sent you a new message!';
  }

  if (type === 'inquiry') {
    subject = 'You have a new message';
    previewText = 'Someone sent you an message!';
  }

  if (type === 'documentVerification') {
    subject = 'Documents verification status';
    previewText = 'Documents verification status';
  }
  if (type === 'contact') {
    subject = 'Contact Form';
    previewText = 'Contact Form';
  }
  if (type === 'reportUser') {
    subject = 'Reporting the User';
    previewText = 'Report User Form';
  }

  return {
    subject,
    previewText,
  };
}



// WEBPACK FOOTER //
// ./src/core/email/template/subjects.js